/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */

/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */
import { styled, type StyledProps } from '@compiled/react';

import { token } from '@atlaskit/tokens';

// eslint-disable-next-line import/order
import type { ComponentType, ClassAttributes, HTMLAttributes } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const AIAnswerSearchLoadingBorder: ComponentType<
	{
		isStreaming: boolean;
	} & ClassAttributes<HTMLDivElement> &
		HTMLAttributes<HTMLDivElement> &
		StyledProps
	// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
> = styled.div<{
	isStreaming: boolean;
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
}>(({ isStreaming }) => ({
	display: 'flex',
	flexDirection: 'column',
	position: 'relative',
	borderRadius: token('space.050'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	padding: isStreaming ? `${token('space.100')} 0 ${token('space.100')} 0` : '0px',
	boxSizing: 'border-box',
	overflow: 'hidden',
	zIndex: 3,
	boxShadow: token('elevation.shadow.overlay'),
	'&::before': {
		content: "''",
		width: '1000vw',
		height: '1000vh',
		// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
		left: 'calc(-500vw + 50%)',
		// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
		top: 'calc(-500vh + 50%)',
		position: 'absolute',
		zIndex: -2,
		borderRadius: token('space.050'),
		background:
			// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
			'conic-gradient( from var(--gradient-angle, 45deg), #BF63F3, #FFA900 25%, #0469FF 67%, #0065FF, #BF63F3)',
		animation: 'rotate 2s infinite linear',
		filter: 'blur(25px)',
	},
	'&::after': {
		content: "''",
		width: `100% - ${token('space.050')}`,
		height: `100% - ${token('space.050')}`,
		inset: '1px',
		position: 'absolute',
		zIndex: -1,
		borderRadius: token('space.050'),
		backgroundColor: token('elevation.surface.overlay'),
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'@keyframes rotate': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
		from: {
			transform: 'rotate(0deg)',
		},
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
		to: {
			transform: 'rotate(360deg)',
		},
	},
}));
